import {
  addRoleFromServer,
  bulkMintTxQueuesPollingFromServer,
  bulkMintTxQueuesPollingRetryFromServer,
  coinTransferFromServer,
  createEntranceCodeFromServer,
  createEntranceFromServer,
  createMetadataUrlWithS3FromCSVFromServer,
  createMetadataUrlWithS3FromServer,
  createNFTKitFromServer,
  createSignatureFromServer,
  getAllTokenBalanceFromServer,
  getCoinBalanceFromServer,
  getEntranceCodeFromServer,
  getEntranceDetailFromServer,
  getEntranceHistoryFromServer,
  getEntranceListFromServer,
  getHolderListFromServer,
  getMyNFTKitsFromServer,
  getMyPublicNFTKitsFromServer,
  getNFTAllowanceHistoryFromServer,
  getNFTApprovalsHistoryFromServer,
  getNFTFunctionListFromServer,
  getNFTFunctionListWithVersionIdFromServer,
  getNFTKitDetailFromServer,
  getNFTKitTypeDetailFromServer,
  getNFTKitTypeListFromServer,
  getNFTKitTypeVersionListFromServer,
  getNFTKitVersionFromServer,
  getNFTTokenSupplyFromServer,
  getNFTTotalSupplyFromServer,
  getNFTTransferHistoryFromServer,
  getPublicNFTKitsFromServer,
  getRoleListFromServer,
  getSupportedChainListFromServer,
  getSupportedModuleContractListFromServer,
  getTokenBalanceFromServer,
  getTokenInfoFromServer,
  nftKitApproveWithServerFromServer,
  nftKitBurnWithServerFromServer,
  nftKitDeployWithServerFromServer,
  nftKitGetMetadataWithServerFromServer,
  nftKitMintWithCSVFileFromServer,
  nftKitMintWithServerFromServer,
  nftKitSetMetadataWithServerFromServer,
  nftKitTransferWithServerFromServer,
  postMyPublicNFTKitsFromServer,
  postNFTKitIdDeployResultFromServer,
  postNFTKitIdForMakeContractFromServer,
  updateEntranceFromServer,
  verifyEntranceCodeFromServer,
} from 'logic/services/NFT-kits/server';
import { callParser, getAbiCodeByContractAddressParser, getAbiCodeByContractIdParser } from 'parser/requestParser';
import { actionController, convertToDecimal } from '../utils';

import { getContractByteCodeFromserver } from 'logic/services/Contract/server';
import { createMetadataImageFromServer, getResourceRegistryListFromServer } from 'logic/services/Metadata-Manager';
import { issuancesObject, transferObject } from 'logic/services/NFT-kits/server/index.type';
import { WEB3 } from 'modules/web3/Web3';
import { encodeABI, encodeABIWithByteCode, overRoadEncodeABI } from 'modules/web3/Web3Utils';
import { uploadTokenImageToS3Parser } from 'parser/currencyParser';
import { TransactionQuery } from 'reducer/clientType/requestClientType';
import { getGasPriceFromServer } from 'server/API/microChainAPI';
import Web3 from 'web3';

export const nftKitsController = {
  // const { tokenKits } = services;
  //유저가 생성한 토큰키트 조회
  getUserNFTKits: (option: { lastId?: number; offset?: number; limit?: number; order?: 'ASC' | 'DESC'; kitIds?: number[] }) => {
    return actionController(async () => {
      try {
        const tokenKits = await getMyNFTKitsFromServer({
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
            ...(option.kitIds && { nftKitIds: option.kitIds }),
          },
        });
        const formattedTokenKits = {
          ...tokenKits,
          rows: tokenKits.rows.map((kit: any) => ({
            ...kit,
            is_public: kit.is_public === 1 ? true : false,
            version: {
              ...kit.version,
              is_public: kit.version.is_public === 1 ? true : false,
              is_latest: kit.version.is_latest === 1 ? true : false,
            },
          })),
        };
        return formattedTokenKits;
      } catch (e) {
        throw new Error('nftKit_get_fail');
      }
    });
  },

  //추가된 Public Token Kit 목록을 조회
  getUserPublicNFTKits: (option: { lastId?: number; offset?: number; limit?: number; order?: 'ASC' | 'DESC' }) => {
    return actionController(async () => {
      try {
        const publicTokenKit = await getMyPublicNFTKitsFromServer({
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
          },
        });
        const formattedTokenKits = {
          ...publicTokenKit,
          rows: publicTokenKit.rows.map((kit: any) => ({
            ...kit,
            is_public: kit.is_public === 1 ? true : false,
            version: {
              ...kit.version,
              is_public: kit.version.is_public === 1 ? true : false,
              is_latest: kit.version.is_latest === 1 ? true : false,
            },
          })),
        };
        return formattedTokenKits;
      } catch (e) {
        throw new Error('user_public_nftKit_get_fail');
      }
    });
  },

  getPublicNFTKits: (option: { lastId?: number; offset?: number; limit?: number; order?: 'ASC' | 'DESC' }) => {
    return actionController(async () => {
      try {
        const publicTokenKit = await getPublicNFTKitsFromServer({
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
          },
        });
        const formattedTokenKits = {
          ...publicTokenKit,
          rows: publicTokenKit.rows.map((kit: any) => ({
            ...kit,
            is_public: kit.is_public === 1 ? true : false,
            version: {
              ...kit.version,
              is_public: kit.version.is_public === 1 ? true : false,
              is_latest: kit.version.is_latest === 1 ? true : false,
            },
          })),
        };
        return formattedTokenKits;
      } catch (e) {
        throw new Error('public_nftKit_get_fail');
      }
    });
  },

  //추가할 토큰 키트 목록
  postPublicNFTKits: (kitIds: number[]) => {
    return actionController(async () => {
      try {
        const publicTokenKit = await postMyPublicNFTKitsFromServer({
          data: {
            nftKitIds: kitIds,
          },
          query: {},
        });
        return publicTokenKit;
      } catch (e) {
        throw new Error('public_nftKit_post_fail');
      }
    });
  },

  getNFTKitDetail: (kitId: number) => {
    return actionController(async () => {
      try {
        const tokenKit = await getNFTKitDetailFromServer({
          params: {
            nftKitId: kitId,
          },
          query: {},
        });
        const formattedTokenKit = {
          ...tokenKit,
          is_public: tokenKit.is_public === 1 ? true : false,
          version: {
            ...tokenKit.version,
            is_public: tokenKit.version.is_public === 1 ? true : false,
            is_latest: tokenKit.version.is_latest === 1 ? true : false,
          },
        };
        return formattedTokenKit;
      } catch (e) {
        if (e.data.errorCode === 'COMM0001') {
          throw new Error('not_access');
        }
        throw new Error('nft_kit_detail_get_fail');
      }
    });
  },

  getNFTKitVersion: (
    kitTypeId: number,
    option: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
    }
  ) => {
    return actionController(async () => {
      try {
        const tokenKitVersion = await getNFTKitVersionFromServer({
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
            kitTypeId: kitTypeId,
          },
        });
        const tokenKitVersionParsed = tokenKitVersion.map((item) => ({
          ...item,
          is_public: item.is_public === 1 ? true : false,
          is_latest: item.is_latest === 1 ? true : false,
        }));
        return tokenKitVersionParsed;
      } catch (e) {
        throw new Error('nft_kit_version_get_fail');
      }
    });
  },

  getNFTTotalSupply: (kitId: number) => {
    return actionController(async () => {
      try {
        const totalSupply = await getNFTTotalSupplyFromServer({
          params: { nftKitId: kitId },
          query: {},
        });
        return totalSupply;
      } catch (e) {
        throw new Error('token_totalSupply_get_fail');
      }
    });
  },

  getNFTTokenSupply: (kitId: number, tokenIds: string[]) => {
    return actionController(async () => {
      try {
        const totalSupply = await getNFTTokenSupplyFromServer({
          params: { nftKitId: kitId },
          query: { tokenIds },
        });
        return totalSupply;
      } catch (e) {
        throw new Error('token_totalSupply_get_fail');
      }
    });
  },

  getNFTFunctionList: (kitId: number) => {
    return actionController(async () => {
      try {
        const FunctionList = await getNFTFunctionListFromServer({
          params: { nftKitId: kitId },
          query: {},
        });
        return FunctionList;
      } catch (e) {
        throw new Error('nft_Function_List_get_fail');
      }
    });
  },

  getNFTFunctionListWithKitTypeId: (kitTypeId: number) => {
    return actionController(async () => {
      try {
        const tokenKitVersion = await getNFTKitVersionFromServer({
          query: { kitTypeId },
        });
        if (!tokenKitVersion) {
          throw new Error('nftKit_version_get_fail');
        }
        const latestTokenKitVersion = tokenKitVersion.filter((item) => item.is_latest === 1);
        const FunctionList = await getNFTFunctionListWithVersionIdFromServer({
          params: { versionId: latestTokenKitVersion[0].version_id },
          query: {},
        });
        return FunctionList;
      } catch (e) {
        throw new Error('nft_Function_List_get_fail');
      }
    });
  },

  // getTokenFunctionMethodList 함수 (feature_id만 받아서 해당하는 functionName과 method 목록을 반환)
  getNFTFunctionMethodList: (feature_id: number, category_id: number) => {
    return actionController(async () => {
      const nftMethods = {
        1: {
          feature_id: 1,
          function_name: 'Issuances',
          description: 'function_name에 대한 description',
          methods: [203, 201, 202, 205, 206, 208, 302], // mint 관련 method_id들
        },
        2: {
          feature_id: 2,
          function_name: 'transfers',
          description: 'function_name에 대한 description',
          methods: [101, 105], // transfer 관련 method_id들
        },
        3: {
          feature_id: 3,
          function_name: 'permissions',
          description: 'function_name에 대한 description',
          methods: [401, 402, 403], // allowance 관련 method_id들
        },
        4: {
          feature_id: 4,
          function_name: 'Voting',
          description: 'function_name에 대한 description',
          methods: [501, 502, 503, 504, 505], // allowance 관련 method_id들
        },
        5: {
          feature_id: 5,
          function_name: 'Entrance',
          description: 'function_name에 대한 description',
          methods: [601, 602, 603, 604], // allowance 관련 method_id들
        },
      };

      const membershipMethods = {
        1: {
          feature_id: 1,
          function_name: 'Issuances',
          description: 'function_name에 대한 description',
          methods: [203, 201, 202, 205, 207, 208, 302], // mint 관련 method_id들
        },
        2: {
          feature_id: 2,
          function_name: 'transfers',
          description: 'function_name에 대한 description',
          methods: [101, , 105], // transfer 관련 method_id들
        },
        3: {
          feature_id: 3,
          function_name: 'permissions',
          description: 'function_name에 대한 description',
          methods: [401, 402, 403], // allowance 관련 method_id들
        },
        4: {
          feature_id: 4,
          function_name: 'Voting',
          description: 'function_name에 대한 description',
          methods: [501, 502, 503, 504, 505], // allowance 관련 method_id들
        },
        5: {
          feature_id: 5,
          function_name: 'Entrance',
          description: 'function_name에 대한 description',
          methods: [601, 602, 603, 604], // allowance 관련 method_id들
        },
      };

      const methodDetails = {
        101: {
          method_id: 101,
          method: 'balanceOf',
          method_description: 'View the amount of tokens you own',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'account', type: 'address', data_type: 'string' }],
        },
        102: {
          method_id: 102,
          method: 'transfer',
          method_description: 'Transfer tokens to another account',
          input_type: 'multiple',
          need_wallet: true,
          owner_only: false,
          input: [
            { name: 'from', type: 'address', data_type: 'string' },
            { name: 'to', type: 'address', data_type: 'string' },
          ],
        },

        105: {
          method_id: 105,
          method: 'transfer-history',
          method_description: 'View the history of token transfer and receipt',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        201: {
          method_id: 201,
          method: 'balanceOf',
          method_description: 'View the amount of tokens you own',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'account', type: 'address', data_type: 'string' }],
        },
        202: {
          method_id: 202,
          method: 'totalSupply',
          method_description: 'View number of current total issued tokens',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [],
        },
        203: {
          method_id: 203,
          method: 'mint',
          method_description: 'Issue tokens to another account',
          input_type: 'multiple',
          need_wallet: true,
          owner_only: true,
          input: [
            { name: 'to', type: 'address', data_type: 'string' },
            { name: 'id', type: 'id', data_type: 'string' },
          ],
        },

        205: {
          method_id: 205,
          method: 'Set Metadata',
          method_description: "Configure or update the token's descriptive information and properties, attributes",
          input_type: 'single',
          need_wallet: true,
          owner_only: true,
          input: [
            { name: 'tokenId', type: 'id', data_type: 'string' },
            { name: 'tokenUri', type: 'url', data_type: 'string' },
          ],
        },
        206: {
          method_id: 206,
          method: 'View NFT Details',
          method_description: 'View Details 관련 설명 ',
          input_type: 'multiple',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'tokenId', type: 'id', data_type: 'string' }],
        },
        207: {
          method_id: 207,
          method: 'View Membership Details',
          method_description: "Access comprehensive information about a specific member's account and status",
          input_type: 'multiple',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'tokenId', type: 'id', data_type: 'string' }],
        },
        208: {
          method_id: 208,
          method: 'Get Member Statistics',
          method_description: 'Retrieve aggregated data and metrics about all members within the network',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [
            { name: 'address', type: 'address', data_type: 'string' },
            { name: 'tokenId', type: 'id', data_type: 'string' },
          ],
        },
        301: {
          method_id: 301,
          method: 'balanceOf',
          method_description: 'View the amount of tokens you own',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'account', type: 'address', data_type: 'string' }],
        },
        302: {
          method_id: 302,
          method: 'burn',
          method_description: 'Burn tokens you own',
          input_type: 'single',
          need_wallet: true,
          owner_only: false,
          input: [
            { name: 'account', type: 'address', data_type: 'string' },
            { name: 'id', type: 'id', data_type: 'string' },
            { name: 'amount', type: 'amount', data_type: 'number' },
          ],
        },

        401: {
          method_id: 401,
          method: 'approve',
          method_description: 'Set the number of tokens that can be transferred instead of the token owner',
          input_type: 'single',
          need_wallet: true,
          owner_only: false,
          input: [{ name: 'operator', type: 'address', data_type: 'string' }],
        },
        402: {
          method_id: 402,
          method: 'allowance',
          method_description: 'View about the number of tokens that can be transferred instead of the token owner',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [
            { name: 'owner', type: 'address', data_type: 'string' },
            { name: 'spender', type: 'address', data_type: 'string' },
          ],
        },
        403: {
          method_id: 403,
          method: 'approval-history',
          method_description:
            'View history of the permissions granted to other accounts by the account address and the permissions granted to the account address.',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        501: {
          method_id: 501,
          method: 'Create Poll',
          method_description: 'Create a poll exclusive to users holding membership NFTs',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        502: {
          method_id: 502,
          method: 'Cast Vote',
          method_description: 'Participate in the poll as a membership NFT holder',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        503: {
          method_id: 503,
          method: 'Get Poll Status',
          method_description: 'Monitor participation metrics and current state of an active poll',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        504: {
          method_id: 504,
          method: 'Update Poll State',
          method_description: 'Manage the operational status of a poll (start, pause, or end voting)',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        505: {
          method_id: 505,
          method: 'Set Poll Condition',
          method_description: 'Configure participation requirements and voting options for a poll',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        601: {
          method_id: 601,
          method: 'Enter',
          method_description: 'Register participation in an event or activity as a membership NFT holder',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        602: {
          method_id: 602,
          method: 'View Enter History',
          method_description: 'Retrieve attendance records and participation history for membership events',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        603: {
          method_id: 603,
          method: 'Set Entrance Conditions',
          method_description: 'Configure access requirements and parameters for membership events',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
        604: {
          method_id: 604,
          method: 'Set Entrance State',
          method_description: 'Record and manage attendance status and activity of NFT holders at events',
          input_type: 'single',
          need_wallet: false,
          owner_only: false,
          input: [{ name: 'address', type: 'address', data_type: 'string' }],
        },
      };

      try {
        // feature_id로 해당하는 기능 정보를 methods 객체에서 가져옵니다.
        let featureInfo: any;

        if (category_id == 2) {
          featureInfo = nftMethods[feature_id];
        }
        if (category_id == 3) {
          featureInfo = membershipMethods[feature_id];
        }

        if (!featureInfo) {
          throw new Error('Invalid feature_id');
        }

        // feature_id에 해당하는 functionName과 method_id 목록을 가져옴
        const { methods: methodIds } = featureInfo;

        // method_id에 해당하는 method 세부 정보들 가져오기
        const methodDetailsList = methodIds.map((methodId: number) => {
          const methodDetail = methodDetails[methodId];

          // methodDetails에서 methodId에 해당하는 정보를 가져오지 못했을 경우 예외 처리
          if (!methodDetail) {
            throw new Error(`Method_details_for_method_id_not_found.`);
          }
          return {
            ...methodDetail,
          };
        });

        return {
          ...featureInfo,
          methods: methodDetailsList,
        };
      } catch (error) {
        throw new Error('Failed_to_get_token_function_method_list');
      }
    });
  },

  // getNFTTokenBalanceOf: (
  //   kitId: number,
  //   tokenId: string,
  //   addresses: string[]
  // ) => {
  //   return actionController(async () => {
  //     try {
  //       const balance = await getNFTBalanceOfFromServer({
  //         params: { nftKitId: kitId },
  //         query: { addresses ,tokenId},
  //       });
  //       const decimal = 18;
  //       const parsedBalance = balance.data.map((balance) => ({
  //         ...balance,
  //         total_supply: convertToDecimal(balance.balance, decimal),
  //       }));

  //       return { ...balance, parsedBalance };
  //     } catch (e) {
  //       throw new Error("token_balance_get_fail");
  //     }
  //   });
  // },

  getNFTTransferHistory: (
    kitId: number,
    address: string,
    option: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      tokenId?: string;
    }
  ) => {
    return actionController(async () => {
      try {
        const transferHistory = await getNFTTransferHistoryFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
            ...(option.tokenId && { tokenId: option.tokenId }),
            address,
          },
        });
        return transferHistory;
      } catch (e) {
        throw new Error('token_transfer_history_fail');
      }
    });
  },

  getNFTApprovalsHistory: (
    kitId: number,
    address: string,
    option: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
    }
  ) => {
    return actionController(async () => {
      try {
        const Approval = await getNFTApprovalsHistoryFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option.lastId && { lastId: option.lastId }),
            ...(option.offset && { offset: option.offset }),
            ...(option.limit && { limit: option.limit }),
            ...(option.order && { order: option.order }),
            address: address,
          },
        });

        return Approval;
      } catch (e) {
        throw new Error('nft_approval_history_fail');
      }
    });
  },

  getNFTAllowanceHistory: (kitId: number, approver: string, operator: string) => {
    return actionController(async () => {
      try {
        const allowance = await getNFTAllowanceHistoryFromServer({
          params: { nftKitId: kitId },
          query: {
            approver,
            operator,
          },
        });

        return allowance;
      } catch (e) {
        throw new Error('nft_allowance_history_fail');
      }
    });
  },

  getSupportedChainList: (versionId: number) => {
    return actionController(async () => {
      try {
        const supportedChain = await getSupportedChainListFromServer({
          params: { versionId },
          query: {},
        });
        const supportedChainList = supportedChain.map((data) => ({
          versionId: data.version_id,
          chainId: data.chain_id,
        }));
        return supportedChainList;
      } catch (e) {
        throw new Error('supported_ChainList_get_fail');
      }
    });
  },

  getSupportedChainListWithKitTypeId: (kitTypeId: number) => {
    return actionController(async () => {
      try {
        const tokenKitVersion = await getNFTKitVersionFromServer({
          query: { kitTypeId },
        });
        if (!tokenKitVersion) {
          throw new Error('tokenKit_version_get_fail');
        }
        const latestTokenKitVersion = tokenKitVersion.filter((item) => item.is_latest === 1);
        const supportedChain = await getSupportedChainListFromServer({
          params: { versionId: latestTokenKitVersion[0].version_id },
          query: {},
        });
        return supportedChain;
      } catch (e) {
        throw new Error('supported_ChainList_get_fail');
      }
    });
  },

  getSupportedModuleContractList: (kitId: number) => {
    return actionController(async () => {
      try {
        const supportedContract = await getSupportedModuleContractListFromServer({
          params: { nftKitId: kitId },
          query: {},
        });
        const supportedChainList = supportedContract.map((data) => ({
          ...data,
          has_constructor: data.has_constructor === 1 ? true : false,
        }));
        return supportedChainList;
      } catch (e) {
        throw new Error('moduleContract_get_fail');
      }
    });
  },

  /*******************************/
  /********* 통합 mint 기능 ********/
  /*******************************/
  nftKitIssuancesWithMetamask: async (
    mintInput: {
      to: string;
      tokenUri?: string;
    }[],
    originMicroChainId: number,
    contractAddress: string
  ) => {
    const tokenId = 0;
    return await actionController(async () => {
      let wallets: any[] = [];

      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);

        if (mintInput.length > 30) {
          //메타마스크로 요청은 30개까지 가능함
          throw new Error('mint_list_over_30');
        }

        if (mintInput.length == 1) {
          // 단일 민트일 경우
          const dataByte = '0x';
          let data = ''; // 기본적으로 mintData로 시작

          if (mintInput[0].tokenUri) {
            //tokenUri 가 있을때 :: setTokenUri 내부적으로 실행

            const parameters = [
              mintInput[0].to, // 배열에서 첫 번째 요소에 접근
              tokenId,
              1, // 수량 1로 fix
              dataByte,
              mintInput[0].tokenUri,
            ];

            // setTokenUri까지 해주는 mint
            data = overRoadEncodeABI(abiCode, 'mint', [parameters]);
          } else {
            //tokenUri 가 없을때
            const parameters = [
              mintInput[0].to, // 배열에서 첫 번째 요소에 접근
              tokenId,
              1, // 수량 1로 fix
              dataByte,
            ];
            // 그냥 mint
            data = overRoadEncodeABI(abiCode, 'mint', [parameters]);
          }

          // 트랜잭션 파라미터 설정
          const txParams = {
            from: account,
            to: contractAddress,
            data: data,
            value: '0x0',
          };

          // 트랜잭션 전송
          try {
            const txHash = await metamaskProvider.provider.request({
              method: 'eth_sendTransaction',
              params: [txParams],
            });
            return txHash;
          } catch (e) {
            throw new Error('tx_send_fail');
          }
        }

        // 다중 민트일 경우 (배열에 요소가 하나 이상 있을 때만)
        if (mintInput.length > 1) {
          const parameters = mintInput.map((transfer) => {
            const dataByte = '0x';

            if (transfer.tokenUri) {
              //tokenUri 가 있을때 :: setTokenUri 내부적으로 실행

              const parameters = [
                transfer.to, // 배열에서 첫 번째 요소에 접근
                tokenId,
                1, // 수량 1로 fix
                dataByte,
                transfer.tokenUri,
              ];

              // setTokenUri까지 해주는 mint
              return overRoadEncodeABI(abiCode, 'mint', [parameters]);
            } else {
              const mintParameters = [transfer.to, tokenId, 1, dataByte]; // 수량 1로 fix

              return overRoadEncodeABI(abiCode, 'mint', [mintParameters]);
            }
          });

          const data = encodeABI(abiCode, 'multicall', [parameters]);

          // 트랜잭션 파라미터 설정
          const txParams = {
            from: account,
            to: contractAddress,
            data: data,
            value: '0x0',
          };

          // 트랜잭션 전송
          try {
            const txHash = await metamaskProvider.provider.request({
              method: 'eth_sendTransaction',
              params: [txParams],
            });
            return txHash;
          } catch (e) {
            throw new Error('tx_send_fail');
          }
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  /*******************************/
  /********* burn 기능 ************/
  /*******************************/

  /*******************************/
  /********* 통합 burn 기능 ********/
  /*******************************/
  nftKitBurnIntegrationWithMetamask: async (
    tokenId: string,
    originMicroChainId: number,
    contractAddress: string,
    option?: {
      redeemingAddress?: string;
    }
  ) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];
        const amount = 1;
        const dataByte = '0x';
        // 컨트랙트 ABI 코드 가져오기
        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);

        const parameters = [
          option?.redeemingAddress ? option?.redeemingAddress : account, // 배열에서 첫 번째 요소에 접근
          tokenId,
          amount, // 배열에서 첫 번째 요소에 접근
          dataByte,
        ];
        const data = encodeABI(abiCode, 'burn', parameters);

        // 트랜잭션 파라미터 설정
        const txParams = {
          from: account,
          to: contractAddress,
          data: data,
          value: '0x0',
        };

        // 트랜잭션 전송
        try {
          const txHash = await metamaskProvider.provider.request({
            method: 'eth_sendTransaction',
            params: [txParams],
          });
          return txHash;
        } catch (e) {
          throw new Error('tx_send_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  /***********************************/
  /********* transfer 기능 ************/
  /***********************************/

  /***********************************/
  /********* 통합 transfer 기능 ********/
  /***********************************/
  nftKitTransferIntegrationWithMetamask: async (
    transfers: {
      toAddress: string;
      tokenId: string;
      fromAddress: string;
    }[],
    originMicroChainId: number,
    contractAddress: string
  ) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);
        const decimal = 18;
        const dataByte = '0x';
        let parameters: any[] = [];
        let functionName: string;
        let data: any;

        // 2개 이상의 트랜잭션이면 multicall, 1개일 경우 transfer 또는 transferFrom
        if (transfers.length > 1) {
          // 다중 전송 (multicall)
          parameters = transfers.map((transfer) => {
            const mintAmount = 1;
            if (transfer.fromAddress) {
              // transferFrom인 경우
              return encodeABI(abiCode, 'safeTransferFrom', [transfer.fromAddress, transfer.toAddress, transfer.tokenId, mintAmount, dataByte]);
            }
          });

          // multicall을 위한 인코딩된 데이터
          data = encodeABI(abiCode, 'multicall', [parameters]);

          functionName = 'multicall';
        } else {
          // 단일 전송 (transfer 또는 transferFrom)
          const transfer = transfers[0];
          const mintAmount = 1;
          if (transfer.fromAddress) {
            // transferFrom인 경우
            parameters = [transfer.fromAddress, transfer.toAddress, transfer.tokenId, mintAmount, dataByte];
            functionName = 'safeTransferFrom';
          }
          // 트랜잭션 데이터 생성
          data = encodeABI(abiCode, 'safeTransferFrom', parameters);
        }

        // 트랜잭션 파라미터 설정
        if (data && parameters && abiCode) {
          const txParams = {
            from: account,
            to: contractAddress,
            data: data,
            value: '0x0',
          };

          // 트랜잭션을 MetaMask를 통해 전송
          try {
            const txHash = await metamaskProvider.provider.request({
              method: 'eth_sendTransaction',
              params: [txParams],
            });
            return txHash;
          } catch (e) {
            throw new Error('tx_send_fail');
          }
        } else {
          throw new Error('make_parameter_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  /***********************************/
  /********* approve 기능 ************/
  /***********************************/

  nftKitApproveTransactionWithMetamask: async (originMicroChainId: number, contractAddress: string, spender: string) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }
        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];
        // const gasPrice = await web3.eth.getGasPrice();

        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);
        const decimal = 18;
        const parameters = [spender, true];
        const data = encodeABI(abiCode, 'setApprovalForAll', parameters);

        // 트랜잭션 파라미터 설정
        if (data && parameters && abiCode) {
          const txParams = {
            from: account, // 현재 MetaMask 연결된 계정
            to: contractAddress, // 컨트랙트 주소
            data: data, // 인코딩된 함수 데이터
            value: '0x0', // 트랜잭션 값 (없으면 0)
            // gasPrice: gasPrice, // gasPrice 설정
          };
          // 트랜잭션을 MetaMask를 통해 전송
          try {
            const txHash = await metamaskProvider.provider.request({
              method: 'eth_sendTransaction',
              params: [txParams],
            });
            return txHash;
          } catch (e) {
            throw new Error('tx_send_fail');
          }
        } else {
          throw new Error('make_parameter_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  nftKitSetMetadataUriWithMetamask: async (originMicroChainId: number, contractAddress: string, tokenId: string, tokenUri: string) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }
        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];
        // const gasPrice = await web3.eth.getGasPrice();

        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);
        const decimal = 18;
        const parameters = [tokenId, tokenUri];
        const data = encodeABI(abiCode, 'setTokenURI', parameters);

        // 트랜잭션 파라미터 설정
        if (data && parameters && abiCode) {
          const txParams = {
            from: account, // 현재 MetaMask 연결된 계정
            to: contractAddress, // 컨트랙트 주소
            data: data, // 인코딩된 함수 데이터
            value: '0x0', // 트랜잭션 값 (없으면 0)
            // gasPrice: gasPrice, // gasPrice 설정
          };
          // 트랜잭션을 MetaMask를 통해 전송
          try {
            const txHash = await metamaskProvider.provider.request({
              method: 'eth_sendTransaction',
              params: [txParams],
            });
            return txHash;
          } catch (e) {
            throw new Error('tx_send_fail');
          }
        } else {
          throw new Error('make_parameter_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  /***********************************/
  /********* deploy 기능 ************/
  /***********************************/

  nftKitDeployTransactionWithMetamask: async (kitId: number) => {
    return await actionController(async () => {
      let wallets: any[] = [];

      try {
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }
        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];
        // const gasPrice = await web3.eth.getGasPrice();
        const nftKit = await getNFTKitDetailFromServer({
          params: {
            nftKitId: kitId,
          },
          query: {},
        });
        if (!nftKit) {
          throw new Error('get_nftKit_detail_fail');
        }

        //지원 모듈 컨트랙트
        const supportedContract = await getSupportedModuleContractListFromServer({
          params: { nftKitId: nftKit.nft_kit_id },
          query: {},
        });

        if (!supportedContract) {
          throw new Error('get_supportedContract_fail');
        }
        //모듈 컨트랙트 Address 목록
        const contractAddressList = supportedContract.map((item) => item.contract_address);

        if (!contractAddressList) {
          throw new Error('make_addressList_fail');
        }

        const moduleContractLnegth = contractAddressList.length;
        const zeroArray = new Array(moduleContractLnegth).fill('0x00');

        const contractByteCode = await getContractByteCodeFromserver({
          params: {
            contractId: nftKit.contract_id,
          },
          query: {},
        });
        const abiCode = await getAbiCodeByContractIdParser(nftKit.contract_id);

        if (!abiCode) {
          throw new Error('make_abiCode_fail');
        }
        const constructorParams = [
          nftKit.name, //token kit 생성할때 사용자가 입력하는 정보
          // tokenKit.symbol, //token kit 생성할때 사용자가 입력하는 정보
          nftKit.admin_address, //token kit의 주인 주소 token kit 상세
          contractAddressList,
          zeroArray, //현재는 0으로
          nftKit.eqhub_address, // eq hub의 어드민 주소 -> token kit 상세
          1, // _maxTokenSupply 값
          kitId, //_kitId
          'nft', //kit type
        ];

        //파라미터 인코딩
        const data = encodeABIWithByteCode(abiCode, contractByteCode.byte_code, constructorParams);

        if (!data) {
          throw new Error('make_parameter_fail'); // data가 없으면 에러를 던지기
        }

        // 트랜잭션 파라미터 설정
        const txParams = {
          from: account, // 현재 MetaMask 연결된 계정
          data: data, // 인코딩된 함수 데이터
          value: '0x0', // 트랜잭션 값 (없으면 0)
        };

        // 트랜잭션을 MetaMask를 통해 전송
        if (metamaskProvider) {
          const txHash = await metamaskProvider.provider.request({
            method: 'eth_sendTransaction',
            params: [txParams],
          });
          return txHash;
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  changeNFTKitStatusProcessing: async (kitId: number) => {
    return await actionController(async () => {
      try {
        const makeDeployStatus = await postNFTKitIdDeployResultFromServer({
          params: { nftKitId: kitId },
          query: {},
        });
        const formattedTokenKits = {
          ...makeDeployStatus,
          is_public: makeDeployStatus.is_public === 1 ? true : false,
          version: {
            ...makeDeployStatus.version,
            is_public: makeDeployStatus.version.is_public === 1 ? true : false,
            is_latest: makeDeployStatus.version.is_latest === 1 ? true : false,
          },
        };
        return formattedTokenKits;
      } catch (error) {
        throw new Error('change_NFTKit_status_fail');
      }
    });
  },

  getNFTKitTypeList: async (option?: { lastId?: number; offset?: number; limit?: number; order?: 'ASC' | 'DESC'; categoryIdentifier?: number }) => {
    return await actionController(async () => {
      try {
        const kitTypeList = await getNFTKitTypeListFromServer({
          params: {},
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.categoryIdentifier && {
              categoryIdentifier: option.categoryIdentifier,
            }),
          },
        });
        return kitTypeList;
      } catch (error) {
        throw new Error('kitTypeList_get_fail');
      }
    });
  },

  getNFTKitTypeDetail: async (kitTypeId: number) => {
    return await actionController(async () => {
      try {
        const kitTypeDetail = await getNFTKitTypeDetailFromServer({
          params: { kitTypeId },
          query: {},
        });
        return kitTypeDetail;
      } catch (error) {
        throw new Error('kitType_detail_get_fail');
      }
    });
  },

  getNFTKitTypeVersionList: async (kitTypeId: number) => {
    return await actionController(async () => {
      try {
        const kitTypeVersionDetail = await getNFTKitTypeVersionListFromServer({
          params: { kitTypeId },
          query: {},
        });
        const kitTypeVersionDetailData = kitTypeVersionDetail.map((item) => ({
          ...item,
          is_public: item.is_public === 1 ? true : false,
          is_latest: item.is_latest === 1 ? true : false,
        }));
        return kitTypeVersionDetailData;
      } catch (error) {
        throw new Error('kitType_version_detail_get_fail');
      }
    });
  },

  /*-----토큰키트 생성-----*/
  createNFTKit: async (versionId: number, isPublic: boolean, name: string, image: string | File, adminAddress: string) => {
    return await actionController(async () => {
      try {
        let tokenKitImageUrl: string;

        // 이미지가 File일 경우 업로드 처리
        if (image instanceof File) {
          const formData = new FormData();
          formData.append('image', image);
          const fileCount = 1;
          const response = await uploadTokenImageToS3Parser(formData, fileCount);

          if (!response) {
            throw new Error('nftKit_upload_image_fail');
          }
          tokenKitImageUrl = response;
        } else {
          // 이미지가 File이 아니면 그냥 URL을 사용
          tokenKitImageUrl = image;
        }
        // tokenKit 생성 요청
        const tokenKit = await createNFTKitFromServer({
          data: {
            versionId,
            isPublic,
            name,
            image: tokenKitImageUrl,
            adminAddress,
          },
          query: {},
        });
        const formattedTokenKits = {
          ...tokenKit,
          is_public: tokenKit.is_public === 1 ? true : false,
          version: {
            ...tokenKit.version,
            is_public: tokenKit.version.is_public === 1 ? true : false,
            is_latest: tokenKit.version.is_latest === 1 ? true : false,
          },
        };
        return formattedTokenKits;
      } catch (error) {
        throw new Error('nftKit_create_fail');
      }
    });
  },

  makeContractInfo: async (kitId: number, chainId: number) => {
    return await actionController(async () => {
      try {
        const tokenKit = await postNFTKitIdForMakeContractFromServer({
          params: { nftKitId: kitId },
          data: { microChainId: chainId },
          query: {},
        });
        const tokenKitData = {
          ...tokenKit,
          is_public: tokenKit.is_public === 1 ? true : false, // 1이면 true, 0이면 false
          version: {
            ...tokenKit.version,
            is_public: tokenKit.version.is_public === 1 ? true : false, // 1이면 true, 0이면 false
            is_latest: tokenKit.version.is_latest === 1 ? true : false, // 1이면 true, 0이면 false
          },
        };
        return tokenKitData;
      } catch (error) {
        throw new Error('make_contract_fail');
      }
    });
  },

  /***********************************/
  /***** account manager를 통한 기능 ****/
  /***********************************/
  nftKitTransferWithServer: async (
    kitId: number,
    password: string,
    useWebhook: boolean,
    transfers: {
      recipientAddress: string;
      tokenId: string;
      option?: {
        senderAddress?: string;
      };
    }[],
    option?: {
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const mappedTransfers: transferObject[] = transfers.map((transfer) => {
          return {
            recipientAddress: transfer.recipientAddress,
            tokenId: transfer.tokenId,
            ...(transfer.option?.senderAddress && {
              senderAddress: transfer.option.senderAddress,
            }),
          };
        });

        if (!mappedTransfers) {
          throw new Error('transfer_parameter_make_fail');
        }

        const transferResult = await nftKitTransferWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            password,
            transferObjects: mappedTransfers,
            useWebhook,
            ...(option?.webhookUrl && {
              webhookUrl: option.webhookUrl,
            }),
          },
        });
        return transferResult.transaction_hash;
      } catch (error) {
        throw new Error('transfer_send_failed');
      }
    });
  },

  //발행
  nftKitIssuancesWithServer: async (
    kitId: number,
    password: string,
    issuances: {
      option?: {
        recipientAddress?: string;
        tokenUri?: string;
      };
    }[],
    option?: {
      webhookUrl?: string;
      useWebhook?: boolean;
    }
  ) => {
    return await actionController(async () => {
      const tokenId = '0';
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }
        const mappedArray: issuancesObject[] = issuances.map((issuance) => {
          return {
            tokenId: tokenId,
            ...(issuance.option?.recipientAddress && {
              recipient: issuance.option.recipientAddress,
            }),
            ...(issuance.option?.tokenUri && {
              tokenUri: issuance.option.tokenUri,
            }),
          };
        });

        if (!mappedArray) {
          throw new Error('issuances_parameter_make_fail');
        }

        const transfer = await nftKitMintWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            password,
            issuanceObjects: mappedArray,
            ...(option?.useWebhook && {
              useWebhook: option.useWebhook,
            }),
            ...(option?.webhookUrl && {
              webhookUrl: option.webhookUrl,
            }),
          },
        });
        return transfer.transaction_hash;
      } catch (error) {
        throw new Error(error.data.message);
      }
    });
  },

  //소각
  nftKitRedeemWithServer: async (
    kitId: number,
    password: string,
    useWebhook: boolean,
    tokenId: string,
    option?: {
      redeemingAddress?: string;
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');
        const amount = '1';
        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const transfer = await nftKitBurnWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            amount: amount.toString(),
            password,
            useWebhook,
            tokenId,
            ...(option?.redeemingAddress && {
              redemptionAddress: option.redeemingAddress,
            }),
            ...(option?.webhookUrl && {
              webhookUrl: option.webhookUrl,
            }),
          },
        });
        return transfer.transaction_hash;
      } catch (error) {
        throw new Error('redeem_send_failed');
      }
    });
  },
  //권한 부여
  nftKitApproveWithServer: async (
    kitId: number,
    password: string,
    authorizedAddress: string,
    useWebhook: boolean,
    isApproved: boolean,
    option?: {
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const approve = await nftKitApproveWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            password,
            authorizedAddress,
            useWebhook,
            isApproved,
            ...(option?.webhookUrl && { webhookUrl: option.webhookUrl }),
          },
        });
        return approve.transaction_hash;
      } catch (error) {
        throw new Error('approve_send_failed');
      }
    });
  },

  nftKitDeployWithServer: async (
    kitId: number,
    // chainId: number,
    password: string
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');
        if (!password) {
          throw new Error('password_notFound');
        }
        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const deploy = await nftKitDeployWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            // chainId,
            password,
          },
        });
        const formattedTokenKit = {
          ...deploy,
          is_public: deploy.is_public === 1 ? true : false,
          version: {
            ...deploy.version,
            is_public: deploy.version.is_public === 1 ? true : false,
            is_latest: deploy.version.is_latest === 1 ? true : false,
          },
        };
        return formattedTokenKit;
      } catch (error) {
        throw new Error('Failed_to_nftKit_deploy');
      }
    });
  },

  //메타데이터 setTokenUri 기능 실행
  nftKitSetMetadataWithServer: async (
    kitId: number,
    password: string,
    tokenId: string,
    metadataUri: string,
    option?: {
      useWebhook?: boolean;
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const metadataUrl = await nftKitSetMetadataWithServerFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            password,
            tokenId,
            tokenUri: metadataUri,
            ...(option?.useWebhook && { useWebhook: option.useWebhook }),
            ...(option?.webhookUrl && { webhookUrl: option.webhookUrl }),
          },
        });
        return metadataUrl.transaction_hash;
      } catch (error) {
        throw new Error('set_metadata_failed');
      }
    });
  },

  //메타데이터 조회
  nftKitGetMetadata: async (kitId: number, tokenId: string) => {
    return await actionController(async () => {
      try {
        const metadata = await nftKitGetMetadataWithServerFromServer({
          params: { nftKitId: kitId },
          query: { tokenId },
          data: {},
        });

        return metadata;
      } catch (error) {
        throw new Error('metadata_get_failed');
      }
    });
  },
  //체인에 요청
  callChainForTokenId: async (originMicroChainId: number, contractAddress: string) => {
    return await actionController(async () => {
      try {
        const abiCode = [
          {
            inputs: [],
            name: 'currentTokenId',
            outputs: [
              {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
              },
            ],
            stateMutability: 'view',
            type: 'function',
          },
        ];

        const dataEncode = encodeABI(abiCode, 'currentTokenId', []);
        const queryObject: TransactionQuery = {
          to: contractAddress,
          data: dataEncode,
        };

        const tokenId: any = await callParser(originMicroChainId, queryObject);

        return tokenId['0'];
      } catch (error) {
        throw new Error('tokenId_get_failed');
      }
    });
  },

  //메타데이터를 통한 s3 url 생성
  createMetadataUrlWithS3: async (
    tokenId: string,
    nftKitId: number,
    categoryIdentifier: number, //어떤 카테고리인지(membership or ..)
    serviceIdentifier: string, //
    option?: {
      tokenMetadata?: any;
    }
  ) => {
    return await actionController(async () => {
      try {
        // 기본적으로 빈 JSON 파일을 생성하여 jsonFile 변수에 할당
        const defaultJsonBlob = new Blob([JSON.stringify({})], {
          type: 'application/json',
        });
        let jsonFile: File = new File([defaultJsonBlob], 'metadata.json', {
          type: 'application/json',
        });

        //조회
        const resourceRegistry = await getResourceRegistryListFromServer({
          params: {},
          query: {
            categoryIdentifier,
            serviceIdentifier,
            resourceIdentifier: nftKitId,
          },
          data: {},
        });
        if (!resourceRegistry) {
          throw new Error('resourceRegistry_get_failed');
        }

        let formData = new FormData(); // if문 밖에서 선언

        //사용자가 템플릿으로 입력한 데이터
        if (option?.tokenMetadata) {
          const key = option?.tokenMetadata.metadata_key;
          const image = option?.tokenMetadata[key];
          if (image) {
            formData.append('image', image);

            const metadata = await createMetadataImageFromServer({
              params: {},
              query: {
                resourceRegistryId: resourceRegistry.rows[0].resource_registry_id,
                fileCount: 1,
              },
              data: formData,
            });

            if (!metadata) {
              throw new Error('image_upload_to_S3_failed');
            }
            option.tokenMetadata[key] = metadata[0].image_uri;
            //폼데이터 초기화
            formData.delete('image');
          }
          const jsonBlob = new Blob([JSON.stringify(option.tokenMetadata)], {
            type: 'application/json',
          });
          jsonFile = new File([jsonBlob], `${tokenId}.json`, {
            type: 'application/json',
          });

          formData.append('metadata', jsonFile);

          const metadataUri = await createMetadataUrlWithS3FromServer({
            params: { nftKitId },
            query: {
              tokenId,
              fileCount: 1,
            },
            data: formData,
          });
          return metadataUri;
        }
      } catch (error) {
        throw new Error('metadata_create_S3_failed');
      }
    });
  },

  //holder 목록 조회
  getHolderList: async (
    kitId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      addresses?: string[];
      tokenIds?: string[];
    }
  ) => {
    return await actionController(async () => {
      try {
        const holder = await getHolderListFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.addresses && { addresses: option.addresses }),
            ...(option?.tokenIds && { tokenIds: option.tokenIds }),
          },
          data: {},
        });
        return holder;
      } catch (error) {
        throw new Error('holder_get_failed');
      }
    });
  },

  //이더리움 주소의 코인잔액 조회
  getCoinBalance: async (microChainId: number, addresses: string[]) => {
    return await actionController(async () => {
      try {
        const coinBalance = await getCoinBalanceFromServer({
          params: {},
          query: { microChainId, addresses },
        });

        const parsedCoinBalance = coinBalance.map((data: any) => {
          // Wei를 Eth로 변환
          const ethBalance = convertToDecimal(data.balance, 18);
          return {
            ...data,
            balance: ethBalance,
          };
        });

        return parsedCoinBalance;
      } catch (error) {
        throw new Error('coinBalance_get_failed');
      }
    });
  },

  //이더리움 주소의 토큰잔액 조회
  getTokenBalance: async (kitId: number, tokenId: string, addresses: string[]) => {
    return await actionController(async () => {
      try {
        const tokenBalance = await getTokenBalanceFromServer({
          params: { nftKitId: kitId },
          query: { addresses, tokenId },
        });

        return tokenBalance;
      } catch (error) {
        throw new Error('tokenBalance_get_failed');
      }
    });
  },

  getAllTokenBalance: async (kitId: number, addresses: string[]) => {
    return await actionController(async () => {
      try {
        const tokenBalance = await getAllTokenBalanceFromServer({
          params: { nftKitId: kitId },
          query: { addresses },
        });

        return tokenBalance;
      } catch (error) {
        throw new Error('tokenBalance_get_failed');
      }
    });
  },

  ///////////////////////////////////////
  //////////// Role /////////////////
  ///////////////////////////////////////

  getRoleList: async (
    kitId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      address?: string;
      role?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const role = await getRoleListFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.address && { address: option.address }),
            ...(option?.role && { role: option.role }),
          },
        });

        return role;
      } catch (error) {
        throw new Error('role_get_failed');
      }
    });
  },

  addRole: async (kitId: number, password: string, address: string, role: string, hasRole: boolean) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const addRole = await addRoleFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
          },
          data: {
            password,
            address,
            role,
            hasRole,
          },
        });

        return addRole;
      } catch (error) {
        throw new Error('add_role_failed');
      }
    });
  },

  ///////////////////////////////////////
  //////////// Entrance /////////////////
  ///////////////////////////////////////

  getEntranceList: async (
    kitId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      entranceName?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const Entrance = await getEntranceListFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.entranceName && { entranceName: option.entranceName }),
          },
          data: {},
        });
        return Entrance;
      } catch (error) {
        throw new Error('get_entrance_failed');
      }
    });
  },

  getEntranceDetail: async (kitId: number, entranceId: number) => {
    return await actionController(async () => {
      try {
        const Entrance = await getEntranceDetailFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {},
          data: {},
        });
        return Entrance;
      } catch (error) {
        throw new Error('get_entrance_failed');
      }
    });
  },

  createEntrance: async (
    kitId: number,
    entranceName: string,
    password: string,
    option?: {
      location?: string;
      expirationTime?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const Entrance = await createEntranceFromServer({
          params: { nftKitId: kitId },
          query: { accountId },
          data: {
            entranceName,
            password,
            ...(option?.location && { location: option.location }),
            ...(option?.expirationTime && {
              expirationTime: option.expirationTime,
            }),
          },
        });
        return Entrance;
      } catch (error) {
        throw new Error('set_entrance_failed');
      }
    });
  },

  updateEntrance: async (
    kitId: number,
    entranceId: number,
    option?: {
      entranceName?: string;
      location?: string;
      expirationTime?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const Entrance = await updateEntranceFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {},
          data: {
            ...(option?.entranceName && { entranceName: option.entranceName }),
            ...(option?.location && { location: option.location }),
            ...(option?.expirationTime && {
              expirationTime: option.expirationTime,
            }),
          },
        });
        return Entrance;
      } catch (error) {
        throw new Error('set_entrance_failed');
      }
    });
  },

  getEntranceHistory: async (
    kitId: number,
    entranceId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      holderAddress?: string;
      tokenId?: string;
      authorizerAddress?: string;
      transactionHash?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const Entrance = await getEntranceHistoryFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.holderAddress && {
              holderAddress: option.holderAddress,
            }),
            ...(option?.tokenId && {
              tokenId: option.tokenId,
            }),
            ...(option?.authorizerAddress && {
              authorizerAddress: option.authorizerAddress,
            }),
            ...(option?.transactionHash && {
              transactionHash: option.transactionHash,
            }),
          },
          data: {},
        });
        return Entrance;
      } catch (error) {
        throw new Error('get_entrance_info_failed');
      }
    });
  },

  createEntranceCode: async (
    kitId: number,
    entranceId: number,
    tokenId: string,
    holderSignature: string,
    option?: {
      endTime: string; //date 형태꼴
    }
  ) => {
    return await actionController(async () => {
      try {
        const Entrance = await createEntranceCodeFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {},
          data: {
            tokenId,
            holderSignature,
            ...(option?.endTime && {
              expirationTime: option.endTime,
            }),
          },
        });
        return Entrance;
      } catch (error) {
        throw new Error('create_entrance_code_failed');
      }
    });
  },

  getEntranceCode: async (
    kitId: number,
    entranceId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      code?: string;
      tokenId?: string;
      status?: number;
    }
  ) => {
    return await actionController(async () => {
      try {
        const Entrance = await getEntranceCodeFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.code && {
              code: option.code,
            }),
            ...(option?.tokenId && {
              tokenId: option.tokenId,
            }),
            ...(option?.status && {
              status: option.status,
            }),
          },
          data: {},
        });
        return Entrance;
      } catch (error) {
        throw new Error('get_entrance_code_failed');
      }
    });
  },

  verifyEntranceCode: async (
    kitId: number,
    entranceId: number,
    password: string,
    tokenId: string,
    holderAddress: string,
    code: string,
    option?: {
      useWebhook?: boolean;
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }
        const Entrance = await verifyEntranceCodeFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {
            accountId,
          },
          data: {
            password,
            tokenId,
            holderAddress,
            code,
            ...(option?.useWebhook && {
              useWebhook: option.useWebhook,
            }),
            ...(option?.webhookUrl && {
              webhookUrl: option.webhookUrl,
            }),
          },
        });
        return Entrance;
      } catch (error) {
        throw new Error('verify_entrance_failed');
      }
    });
  },

  createSignature: async (kitId: number, entranceId: number, password: string, tokenId: string) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }
        const Entrance = await createSignatureFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {
            accountId,
          },
          data: {
            password,
            tokenId,
          },
        });
        return Entrance;
      } catch (error) {
        throw new Error('create_signature_failed');
      }
    });
  },

  getTokenInfo: async (
    kitId: number,
    option?: {
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: 'ASC' | 'DESC';
      tokenIds?: string[];
    }
  ) => {
    return await actionController(async () => {
      try {
        const tokenInfo = await getTokenInfoFromServer({
          params: { nftKitId: kitId },
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.tokenIds && {
              tokenIds: option.tokenIds,
            }),
          },
          data: {},
        });
        const tokenIds: string[] = [];

        tokenInfo.rows.forEach((kit) => {
          tokenIds.push(kit.token_id);
        });

        const holder = await getHolderListFromServer({
          params: { nftKitId: kitId },
          query: {
            tokenIds,
          },
          data: {},
        });

        const rowsWithTemplateData = await Promise.all(
          tokenInfo.rows.map(async (row) => {
            // 매칭되는 holder들 찾기
            let holderAddresses: string = '';

            // token_id에 맞는 모든 holder의 address를 찾기
            holder.rows.forEach((holderRow) => {
              if (holderRow.token_id === row.token_id) {
                holderAddresses = holderRow.address; // holder의 주소를 holderAddresses 배열에 추가
              }
            });

            // token_uri가 있을 경우 S3에서 metadata 가져오기
            let jsonData: any;
            if (row.token_uri) {
              const s3Url = row.token_uri;
              try {
                const response = await fetch(s3Url, { cache: 'no-store' });

                if (!response.ok) {
                  throw new Error('Failed_to_fetch_JSON_from_S3');
                }

                jsonData = await response.json();
              } catch (error) {
                jsonData = undefined; // 만약 실패하면 jsonData는 undefined로 설정
              }
            }
            // 각 row에 holder_addresses 추가
            return {
              ...row,
              holder_address: holderAddresses ? holderAddresses : undefined, // 여러 개일 경우 배열로
              metadata: jsonData ? jsonData : undefined, // token_uri가 있으면 metadata 추가
            };
          })
        );

        return {
          count: tokenInfo.count,
          rows: rowsWithTemplateData,
        };
      } catch (error) {
        throw new Error('get_tokenInfo_failed');
      }
    });
  },

  //eip712 서명 요청
  eip712Signed: async (originMicroChainId: number, contractAddress: string, tokenId: string, actionHash: string, tokenNonce: string) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        const domain = {
          chainId: originMicroChainId,
          name: 'NFT Metadata',
          verifyingContract: contractAddress,
          version: '1',
        };

        const types = {
          ExecuteAction: [
            { type: 'string', name: 'tokenId' },
            { type: 'string', name: 'actionHash' },
            { type: 'string', name: 'tokenNonce' },
          ],
          EIP712Domain: [
            { name: 'name', type: 'string' },
            { name: 'version', type: 'string' },
            { name: 'chainId', type: 'uint256' },
            { name: 'verifyingContract', type: 'address' },
          ],
        };

        const message = {
          tokenId,
          actionHash,
          tokenNonce,
        };

        // EIP-712 서명 요청
        const signature = await metamaskProvider.provider.request({
          method: 'eth_signTypedData_v4',
          params: [
            account,
            JSON.stringify({
              types,
              domain,
              primaryType: 'ExecuteAction',
              message,
            }),
          ],
        });

        return signature;
      } catch (error) {
        throw new Error('eip712_signature_failed');
      }
    });
  },

  addRoleWithMetamask: async (
    originMicroChainId: number,
    contractAddress: string,
    role: string,
    option?: {
      hasRole?: boolean;
    }
  ) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const grantRoleAbiCode = [
          {
            inputs: [
              {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
              },
              {
                internalType: 'address',
                name: 'account',
                type: 'address',
              },
            ],
            name: 'grantRole',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
          },
        ];

        const revokeRoleAbiCode = [
          {
            inputs: [
              {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
              },
              {
                internalType: 'address',
                name: 'account',
                type: 'address',
              },
            ],
            name: 'revokeRole',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
          },
        ];

        const { gas_price }: any = await getGasPriceFromServer({
          params: { microChainId: originMicroChainId },
        });

        const adminRoleHash = Web3.utils.keccak256(role);
        const parameters = [
          adminRoleHash,
          account, // 배열에서 첫 번째 요소에 접근
        ];
        let data = '';

        if (option?.hasRole === true) {
          data = encodeABI(grantRoleAbiCode, 'grantRole', parameters);
        } else {
          data = encodeABI(revokeRoleAbiCode, 'revokeRole', parameters);
        }

        let web3 = new Web3();
        const gasEstimate = await web3.eth.estimateGas({
          from: account,
          to: contractAddress,
          value: 0x0,
          data: data,
        });

        // 트랜잭션 파라미터 설정
        const txParams = {
          from: account,
          to: contractAddress,
          data: data,
          value: '0x0',
          gas: gasEstimate.toString(),
          gasPrice: gas_price,
        };

        // 트랜잭션 전송

        const txHash = await metamaskProvider.provider.request({
          method: 'eth_sendTransaction',
          params: [txParams],
        });
        return txHash;
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  createEntranceWithMetamask: async (contractAddress: string, entranceName: string) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const abiCode = [
          {
            inputs: [
              {
                internalType: 'bytes32',
                name: 'actionHash',
                type: 'bytes32',
              },
            ],
            name: 'addActionHash',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
          },
        ];

        const adminRoleHash = Web3.utils.keccak256(entranceName);

        const parameters = [adminRoleHash];

        const data = encodeABI(abiCode, 'addActionHash', parameters);

        // 트랜잭션 파라미터 설정
        const txParams = {
          from: account,
          to: contractAddress,
          data: data,
          value: '0x0',
        };

        // 트랜잭션 전송
        try {
          const txHash = await metamaskProvider.provider.request({
            method: 'eth_sendTransaction',
            params: [txParams],
          });
          return txHash;
        } catch (e) {
          throw new Error('tx_send_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  verifyEntranceCodeWithMetamask: async (
    originMicroChainId: number,
    contractAddress: string,
    tokenId: string,
    code: string,
    entranceId: number,
    kitId: number
  ) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);

        const Entrance = await getEntranceDetailFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {},
          data: {},
        });

        if (!Entrance) {
          throw new Error('Entrance_info_notFound');
        }

        const entranceCode = await getEntranceCodeFromServer({
          params: { nftKitId: kitId, entranceId },
          query: { code },
          data: {},
        });

        if (!entranceCode) {
          throw new Error('entranceCode_info_notFound');
        }

        // account 로 시그니처 생성

        const dataEncode = encodeABI(abiCode, 'eip712Domain', []);

        const queryObject: TransactionQuery = {
          to: contractAddress,
          data: dataEncode,
        };

        const eip712domain = await callParser(originMicroChainId, queryObject);

        let web3 = new Web3();
        //tokenNonce 조회
        const tokenNonceAbiCode = [
          {
            inputs: [
              {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
              },
            ],
            name: 'tokenNonce',
            outputs: [
              {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
              },
            ],
            stateMutability: 'view',
            type: 'function',
          },
        ];

        const tokenNonceData = encodeABI(tokenNonceAbiCode, 'tokenNonce', [parseInt(tokenId, 10)]);

        if (!tokenNonceData) {
          throw new Error('tx_make_fail');
        }
        const tokenNonceQueryObject: TransactionQuery = {
          to: contractAddress,
          data: tokenNonceData,
        };

        const tokenNonce: any = await callParser(originMicroChainId, tokenNonceQueryObject);

        const types = {
          ExecuteAction: [
            { type: 'uint256', name: 'tokenId' },
            { type: 'bytes32', name: 'actionHash' },
            { type: 'uint256', name: 'tokenNonce' },
          ],
          EIP712Domain: [
            { name: 'name', type: 'string' },
            { name: 'version', type: 'string' },
            { name: 'chainId', type: 'uint256' },
            { name: 'verifyingContract', type: 'address' },
          ],
        };

        const domain = {
          name: eip712domain[1],
          version: eip712domain[2],
          chainId: parseInt(eip712domain[3], 10),
          verifyingContract: eip712domain[4],
        };

        const data = {
          tokenId: parseInt(tokenId, 10), // tokenId를 숫자로 변환
          actionHash: Entrance.entrance_hash, // 이미 bytes32 형식이므로 그대로 사용
          tokenNonce: web3.utils.hexToNumber(tokenNonce.data), // tokenNonce를 숫자로 변환
        };

        const authorizerSignature = await metamaskProvider.provider.request({
          method: 'eth_signTypedData_v4',
          params: [
            account,
            {
              types,
              primaryType: 'ExecuteAction',
              domain,
              message: data,
            },
          ],
        });

        const executeActionAbiCode = [
          {
            inputs: [
              {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
              },
              {
                internalType: 'bytes32',
                name: 'actionHash',
                type: 'bytes32',
              },
              {
                internalType: 'bytes',
                name: 'ownerSignature', // holderSignature
                type: 'bytes',
              },
              {
                internalType: 'bytes',
                name: 'authorizerSignature', // accountId address
                type: 'bytes',
              },
            ],
            name: 'executeAction',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
          },
        ];

        const parameters = [
          parseInt(tokenId, 10),
          Entrance.entrance_hash, //actionHash
          entranceCode.rows[0].holder_signature, //ownerSignature
          authorizerSignature,
        ];

        //////////////////////////////
        const executeActionData = encodeABI(executeActionAbiCode, 'executeAction', parameters);

        const { gas_price }: any = await getGasPriceFromServer({
          params: { microChainId: originMicroChainId },
        });

        const gasEstimate = await web3.eth.estimateGas({
          from: account,
          to: contractAddress,
          value: '0x0',
          data: executeActionData,
        });

        // 트랜잭션 파라미터 설정
        const txParams = {
          from: account,
          to: contractAddress,
          data: executeActionData,
          value: '0x0',
          gas: gasEstimate.toString(),
          gasPrice: gas_price,
        };

        // 트랜잭션 전송

        const txHash = await metamaskProvider.provider.request({
          method: 'eth_sendTransaction',
          params: [txParams],
        });
        return txHash;
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  createSignatureWithMetamask: async (originMicroChainId: number, contractAddress: string, tokenId: string, entranceId: number, kitId: number) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        // EIP6963을 통해 wallet provider 요청
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });

        // MetaMask provider 찾기
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }

        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];

        // 컨트랙트 ABI 코드 가져오기
        const abiCode = await getAbiCodeByContractAddressParser(originMicroChainId, contractAddress);

        const Entrance = await getEntranceDetailFromServer({
          params: { nftKitId: kitId, entranceId },
          query: {},
          data: {},
        });

        if (!Entrance) {
          throw new Error('Entrance_info_notFound');
        }

        // account 로 시그니처 생성

        const dataEncode = encodeABI(abiCode, 'eip712Domain', []);
        const queryObject: TransactionQuery = {
          to: contractAddress,
          data: dataEncode,
        };

        const eip712domain = await callParser(originMicroChainId, queryObject);

        //tokenNonce 조회
        const tokenNonceAbiCode = [
          {
            inputs: [
              {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
              },
            ],
            name: 'tokenNonce',
            outputs: [
              {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
              },
            ],
            stateMutability: 'view',
            type: 'function',
          },
        ];

        const tokenNonceData = encodeABI(tokenNonceAbiCode, 'tokenNonce', [tokenId]);

        if (!tokenNonceData) {
          throw new Error('tx_make_fail');
        }
        const tokenNonceQueryObject: TransactionQuery = {
          to: contractAddress,
          data: tokenNonceData,
        };

        const tokenNonce: any = await callParser(originMicroChainId, tokenNonceQueryObject);

        const domain = {
          name: eip712domain[1],
          version: eip712domain[2],
          chainId: parseInt(eip712domain[3], 10),
          verifyingContract: eip712domain[4],
        };

        const types = {
          ExecuteAction: [
            { type: 'uint256', name: 'tokenId' },
            { type: 'bytes32', name: 'actionHash' },
            { type: 'uint256', name: 'tokenNonce' },
          ],
          EIP712Domain: [
            { name: 'name', type: 'string' },
            { name: 'version', type: 'string' },
            { name: 'chainId', type: 'uint256' },
            { name: 'verifyingContract', type: 'address' },
          ],
        };
        const decimalValue = BigInt(tokenNonce.data).toString();

        const data = {
          tokenId: parseInt(tokenId, 10), // tokenId를 숫자로 변환
          actionHash: Entrance.entrance_hash, // 이미 bytes32 형식이므로 그대로 사용
          tokenNonce: parseInt(decimalValue, 10), // tokenNonce를 숫자로 변환
        };

        const authorizerSignature = await metamaskProvider.provider.request({
          method: 'eth_signTypedData_v4',
          params: [
            account,
            {
              types,
              primaryType: 'ExecuteAction',
              domain,
              message: data,
            },
          ],
        });

        return {
          signature: authorizerSignature,
        };
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  coinTransferWithMetamask: async (toAddress: string, value: number) => {
    return await actionController(async () => {
      let wallets: any[] = [];
      try {
        await Web3.requestEIP6963Providers().then(async (res: any) => {
          for (const [key, value] of res) {
            wallets.push(value);
          }
        });
        const metamaskProvider = wallets.find((wallet) => wallet.info.name === 'MetaMask');
        if (!metamaskProvider) {
          throw new Error('metamask_account_notFound');
        }
        // MetaMask에서 사용할 계정 가져오기
        const accounts = await metamaskProvider.provider.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts[0];
        // const gasPrice = await web3.eth.getGasPrice();

        const value_ = WEB3.toWei(value.toString()); // 1 Ether를 Wei로 변환
        const hxValue = WEB3.toHex(BigInt(value_));

        // 트랜잭션 파라미터 설정
        if (account) {
          const txParams = {
            from: account, // 보내는 계정
            to: toAddress, // 받는 사람 주소
            value: hxValue, // 1 Ether (1000000000000000000 Wei)
          };

          // 트랜잭션을 MetaMask를 통해 전송

          const txHash = await metamaskProvider.provider.request({
            method: 'eth_sendTransaction',
            params: [txParams],
          });
          return txHash;
        } else {
          throw new Error('make_parameter_fail');
        }
      } catch (error) {
        throw new Error('tx_make_fail');
      }
    });
  },

  coinTransferWithServer: async (
    microChainId: number,
    password: string,
    toAddress: string,
    value: number,
    option?: {
      useWebhook?: boolean;
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const transfer = await coinTransferFromServer({
          params: {},
          query: {
            microChainId,
            accountId,
          },
          data: {
            password,
            recipientAddress: toAddress,
            amount: value.toString(),
            ...(option?.useWebhook && { useWebhook: option.useWebhook }),
            ...(option?.webhookUrl && { webhookUrl: option.webhookUrl }),
          },
        });
        return transfer;
      } catch (error) {
        throw new Error('coin_transfer_fail');
      }
    });
  },

  createCSVFile: async (images: { imageName: string }[]) => {
    return await actionController(async () => {
      try {
        // CSV 데이터 준비 (예시로 이미지 URL과 이름 포함)
        const headers = ['id', 'media', 'name', 'description', 'recipient(to)'];
        const data = images || []; // images 배열이 option에서 전달되면 사용, 없으면 빈 배열

        // CSV 형식으로 변환
        const csvRows: string[] = [];
        csvRows.push(headers.join(',')); // 헤더 추가

        // 데이터 추가
        data.forEach((item, index) => {
          // 순서(index)와 이미지 URL을 추가
          csvRows.push(`${index + 1},${item.imageName},"","",""`); // 순서를 설정
        });

        // CSV 문자열 생성
        const csvString = csvRows.join('\n');

        // Blob을 사용하여 CSV 파일 생성
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

        try {
          // 다운로드 링크 생성
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'kit_batchmint.csv'; // 다운로드할 파일명 :: 정해야함
          link.click(); // 다운로드 시작
        } catch (e) {
          //실패했을 시 에러 반환
          return e;
        }
        return 'success';
      } catch (error) {
        throw new Error('create_csvFile_fail');
      }
    });
  },

  //metamask로 csv파일 올려서 tokenUri 받는거
  createS3UrlFromFiles: async (kitId: number, file: File) => {
    return await actionController(async () => {
      try {
        const formData = new FormData();

        formData.append('csv', file); // 여러 파일을 'files'라는 이름으로 추가

        // 파일 수를 fileCount로 서버에 전달
        const metadataUri = await createMetadataUrlWithS3FromCSVFromServer({
          params: { nftKitId: kitId },
          query: {
            fileCount: 1,
          },
          data: formData,
        });

        return metadataUri;
      } catch (error) {
        throw new Error('upload_csv_to_server_fail');
      }
    });
  },

  //이미지 파일 업로드
  createS3UrlFromImageFiles: async (files: File[], kitId: number, categoryIdentifier: number, serviceIdentifier: string): Promise<any> => {
    return await actionController(async () => {
      try {
        const BATCH_SIZE = 100; // 한 번에 처리할 파일 수
        const batchPromises: Promise<any>[] = []; // 각 배치의 요청을 담을 배열

        // 서버에서 리소스 레지스트리 가져오기
        const resourceRegistry = await getResourceRegistryListFromServer({
          params: {},
          query: {
            categoryIdentifier,
            serviceIdentifier,
            resourceIdentifier: kitId,
          },
          data: {},
        });

        // 파일을 100개씩 배치로 나누어 Promise 배열 생성
        for (let i = 0; i < files.length; i += BATCH_SIZE) {
          const fileBatch = files.slice(i, i + BATCH_SIZE);

          const formData = new FormData();

          // 파일들을 FormData에 추가
          fileBatch.forEach((file) => {
            formData.append('image', file); // 여러 파일을 'files'라는 이름으로 추가
          });

          // 각 배치에 대한 요청을 Promise로 생성하고, metadataPromises 배열에 추가
          const batchPromise = createMetadataImageFromServer({
            params: {},
            query: {
              resourceRegistryId: resourceRegistry.rows[0].resource_registry_id,
              fileCount: fileBatch.length, // 해당 배치의 파일 수
            },
            data: formData, // formData로 파일 전달
          });
          batchPromises.push(batchPromise); // 각 배치의 요청을 배열에 추가
        }

        // 모든 배치 요청을 병렬로 처리
        const metadataResults = await Promise.all(batchPromises);

        return metadataResults;
      } catch (error) {
        throw new Error('upload_image_to_s3_fail');
      }
    });
  },

  bulkMintHistoryPolling: async (
    batchIssuanceJobId: number,
    isPolling: boolean,
    kitId: number,
    interval: number, // 폴링 간격
    maxAttempts: number, // 최대 시도 횟수
    callback: (result: any) => void
  ) => {
    return await actionController(async () => {
      let attempt = 0;
      console.log(attempt);
      const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

      while (attempt < maxAttempts && isPolling) {
        try {
          const bulkMint = await bulkMintTxQueuesPollingFromServer({
            params: {
              nftKitId: kitId,
              batchIssuanceJobId,
            },
            query: {},
            data: {},
          });

          //외부 set함수에 넣어주기
          callback(bulkMint);

          //나와야하는 값이 전부 조회되었을때
          if (bulkMint.job_status === 'executed' || bulkMint.job_status === 'failed' || bulkMint.job_status === 'completed') {
            return bulkMint;
          }

          // 폴링 간격만큼 대기

          attempt++;
          await delay(interval); // 3초 대기 후 다시 시도
        } catch (error) {
          throw new Error('Polling_failed_during_execution.');
        }
      }
      if (!isPolling) {
        throw new Error('Max_polling_attempts_reached');
      }
      if (attempt >= maxAttempts) {
        throw new Error('Max_polling_attempts_reached');
      }
    });
  },

  //기존에 실패했던 bulk mint를 재시도
  bulkMintHistoryRetry: async (
    batchIssuanceId: number,
    kitId: number,
    password: string,
    option?: {
      useWebhook?: boolean;
      webhookUrl?: string;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const bulkMint = await bulkMintTxQueuesPollingRetryFromServer({
          params: {
            nftKitId: kitId,
            batchIssuanceId,
          },
          query: {
            accountId,
          },
          data: {
            password,
            ...(option?.useWebhook && {
              useWebhook: option.useWebhook,
            }),
            ...(option?.webhookUrl && {
              webhookUrl: option.webhookUrl,
            }),
          },
        });
        return bulkMint.transaction_hash;
      } catch (error) {
        throw new Error('bulkMint_retry_fail');
      }
    });
  },

  //서버에 csv파일 업로드하고 서버 내부적으로 mint까지 수행하게 하는 요청
  //응답이 오면 서버에서 tokenUri를 만들었다는 의미임.
  nftKitCSVFileIssuancesWithServer: async (
    kitId: number,
    password: string,
    csv: File,
    option?: {
      webhookUrl?: string;
      useWebhook?: boolean;
      isForce?: boolean;
    }
  ) => {
    return await actionController(async () => {
      try {
        const accountId = sessionStorage.getItem('connectedWalletId');

        if (!accountId) {
          throw new Error('no_connected_wallet');
        }

        const formData = new FormData();
        formData.append('csv', csv);
        formData.append('password', password);

        if (option?.useWebhook) {
          const useWebhook = option?.useWebhook.toString();
          formData.append('useWebhook', useWebhook);
        }

        if (option?.webhookUrl) {
          formData.append('webhookUrl', option?.webhookUrl);
        }

        const transfer = await nftKitMintWithCSVFileFromServer({
          params: { nftKitId: kitId },
          query: {
            accountId,
            fileCount: 1,
            ...(option?.isForce && {
              isForce: option.isForce,
            }),
          },
          data: formData,
        });
        return transfer;
      } catch (error) {
        throw new Error(error.data.message);
      }
    });
  },
};
